import { TimelineMax, Power3, Expo } from 'gsap';
import cursor from '@/scripts/cursor';

const LoadDone = (element) => {
  const loader = element;
  const logo = element.querySelector('.loader__logo');
  const headerLogo = document.querySelector('.logo');
  const menu = document.querySelector('.menu-voices');
  const sound = document.querySelector('.sound-controller');
  const sliderFooter = document.querySelector('.slider__footer');
  const cursorCircle = document.querySelector('.cursor-container circle');

  const tl = new TimelineMax({ paused: true, delay: 0.3 });
  tl.addLabel('start')
    .set([menu, headerLogo], { y: -60, autoAlpha: 0 })
    .set([sound, sliderFooter], { y: 60, autoAlpha: 0 })
    .to(logo, 0.6, {
      y: 60,
      autoAlpha: 0,
      ease: Power3.easeIn,
    }, 'start')
    .to(cursorCircle, 1, {
      strokeDashoffset: 0,
      ease: Expo.easeInOut,
    }, 'start+=0.2')
    .addCallback(() => { cursor.ref.getProperty('r').pause(); }, 'start+=1')
    .to(cursorCircle, 1, {
      attr: {
        r: 30,
      },
      ease: Expo.easeInOut,
      onComplete: () => { cursor.ref.getProperty('r').play(30); },
    }, 'start+=1')
    .to(loader, 0.8, {
      autoAlpha: 0,
      ease: Expo.easeInOut,
    }, 'start+=0.4')
    .to([menu, headerLogo], 0.6, {
      y: 0,
      autoAlpha: 1,
      ease: Power3.easeOut,
    }, 'start+=0.6')
    .to([sound, sliderFooter], 0.6, {
      y: 0,
      autoAlpha: 1,
      ease: Power3.easeOut,
    }, 'start+=0.8');
  return tl;
};

export default LoadDone;
